import Vue from 'vue'
import VueI18n from 'vue-i18n'
import _ from 'lodash'

import lokaliseData from '../../../scripts/data/lokalise.json'

Vue.use(VueI18n)

export default (brand, store, defaultLocale = 'en') => {
  const brandSpecific = require(`~locale/brands/${brand}`)
  const common = require('~locale/common')
  const buildDateTimeFormats = require('~locale/dateTimeFormats').default

  const availableLocales = _.difference(
    Object.keys(brandSpecific.messages),
    _.get(lokaliseData, `projects[${brand}].disabledLanguages`),
  )

  const dateTimeFormats = buildDateTimeFormats(availableLocales)

  const messages = _.merge(
    _.pickBy(common.messages, (value, key) => availableLocales.includes(key)),
    _.pickBy(brandSpecific.messages, (value, key) => availableLocales.includes(key)),
  )

  const i18n = new VueI18n({
    locale: defaultLocale,
    fallbackLocale: 'en',
    // availableLocales is read only
    messages,
    dateTimeFormats,
  })

  // eslint-disable-next-line no-param-reassign
  store.$i18n = i18n

  return i18n
}
